const $ = require("jquery");

module.exports = {
	validateFields: validateFields
};

var emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	 phonePattern = /^(\+|[0-9])(([ \-]|[\-])?)?((\(\d{3}\))|(\d{3}))?([ \-])?(\d{3}[\- ]?\d{2}[\- ]?\d{2,6})$/;

$("[data-check]").on('change keyup', function() {
	validateFields($(this));
});

$('form').on('submit', function(event) {
	event.stopImmediatePropagation();
	var validation = validateFields($(this).find("[data-check]"));
	if(validation !== true){
		event.preventDefault();
	} else {
		$(this).trigger('submit_success');
		event.returnValue = true;
	}
});

function validateFields(fields) {
	var errors = 0;

	$.each($(fields), function(index, val) {
		var $this = $(val),
		    value = $this.val(),
		    name  = $this.attr('name'),
		    ok    = false;

		switch(name) {
			case 'email':
				if (emailPattern.test(value)) { ok = true; }
				break;

			case 'phone':
				if (phonePattern.test(value)) { ok = true; }
				break;

			/*case 'phone_code':
				if (value.length >= 2 && value.length <= 4) {
					ok = true;
				}
				break;*/

			case 'agreement':
				if ($this.prop('checked')) {
					ok = true;
					$this.next('.checkmark').removeClass("error").addClass('ok');
				} else {
					$this.next('.checkmark').removeClass("ok").addClass('error');
				}
				break;

			default:
				if (value.length >= 3) { ok = true; }
				break;
		}

		if (ok) {
			$this.removeClass("error").addClass('ok');
		} else {
			$this.removeClass("ok").addClass('error');
			errors++;
		}
	});

	return errors ? false : true;
}
